/**
 * Load Youtube Player dynamically
 */

export default class YoutubePlayerChunk {
  static body: HTMLElement;

  static styleCreated = false;

  static loadScript = false;

  static preconnect = false;

  static videoPlayers: NodeList = document.querySelectorAll('.js-videoPlayer');

  private static observer: IntersectionObserver;

  constructor() {
    let poster: HTMLElement;
    let playerInViewport: Element;

    if (YoutubePlayerChunk.videoPlayers) {
      const observer = new IntersectionObserver(
        (elements: IntersectionObserverEntry[]) => {
          elements.forEach((player: IntersectionObserverEntry) => {
            if (player.isIntersecting) {
              playerInViewport = player.target;
              YoutubePlayerChunk.loadYoutubeApi(playerInViewport);
              if (!poster) {
                poster = player.target.parentElement.querySelector(
                  '.bloc-video__player__poster'
                );
              }
            }
          });
        }
      );

      YoutubePlayerChunk.observer = observer;

      YoutubePlayerChunk.videoPlayers.forEach((player: HTMLElement) => {
        observer.observe(player);
      });

      // Add API to scroll in page
      document.addEventListener(
        'scroll',
        YoutubePlayerChunk.preconnectYoutubeApi,
        { once: true }
      );

      // Add event click to poster video
      if (poster) {
        poster.addEventListener(
          'click',
          () => YoutubePlayerChunk.loadYoutubeApi(playerInViewport),
          {
            once: true,
          }
        );
      }
    }
  }

  /**
   * Load Youtube API
   */
  static preconnectYoutubeApi = (): void => {
    // if user start scrolling : preconnect to youtube iframe API
    if (!YoutubePlayerChunk.preconnect) {
      YoutubePlayerChunk.preconnect = true;
      const preconnectScript = document.createElement('link');
      preconnectScript.href = 'https://www.youtube.com/iframe_api';
      preconnectScript.rel = 'preconnect';
      preconnectScript.crossOrigin = 'true';
      document.head.append(preconnectScript);
    }
  };

  /**
   * Load Youtube API
   */
  static loadYoutubeApi = (player: Element): void => {
    // if block video is in view : load youtube iframe API
    if (!YoutubePlayerChunk.loadScript && player) {
      YoutubePlayerChunk.loadScript = true;
      YoutubePlayerChunk.loadIframePlayerApi();
    }
  };

  /*
   * This code loads the IFrame Player API code asynchronously.
   */
  static loadIframePlayerApi = (): void => {
    const jsFile = document.createElement('script');
    jsFile.defer = true;
    jsFile.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(jsFile, firstScriptTag);
    // After JS API loaded
    jsFile.onload = () => {
      import(
        /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-YoutubePlayerLoadScript' */ '../../../components/YoutubePlayer/YoutubePlayer'
      ).then(({ default: YoutubePlayer }) => {
        new YoutubePlayer();
      });
    };
  };
}
